import React from "react";
import { useContext } from "react";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthProvider/AuthProvider";
import { FaUserAlt } from "react-icons/fa";
const Header = () => {
  const { user, logout } = useContext(AuthContext);
  return (
    <div>
      <Navbar bg="light" variant="light">
        <Container>
          <Navbar.Brand href="#home">Navbar</Navbar.Brand>
          <Nav className="me-auto ">
            <Link className="me-2" to="/">
              Home
            </Link>
            <Link className="me-2" to="/news">
              News
            </Link>
            <Link className="me-2" to="/">
              Catagories
            </Link>
            <p>
              {user?.uid ? (
                <>
                  <span>{user?.displayName}</span>
                  <button onClick={logout}>Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login">Login</Link>
                  <Link to="/register">Register</Link>
                </>
              )}
            </p>
            {user?.photoURL ? (
              <Image
                style={{ height: "30px" }}
                roundedCircle
                src={user.photoURL}
              ></Image>
            ) : (
              <FaUserAlt></FaUserAlt>
            )}
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
